import {scheduleListModalData} from "../types/planSelectConfirm";

export const defaultScheduleListData: scheduleListModalData = {
  travelSchedule: [],
  useOptions: false,
  useCarRental: false,
};